<template>
  <div class="recommendList">
    <div class="recommendListWrap">
      <h3 class="recommendListTitle">
        产品筛选<span>共{{ total }}款产品</span>
      </h3>
      <div class="recommendListFilter">
        <div class="recommendFilterItem">
          <span class="filterType">投保方式：</span>
          <span
            class="filterLabel"
            :class="{ active: item.id === initParam.param.typeId }"
            v-for="(item,index) in typeList"
            :key="index"
            @click="handleTab('typeId', item.id)"
          >
            {{ item.typeName }}
          </span>
        </div>
        <div class="recommendFilterItem">
          <span class="filterType">保险分类：</span>
          <span
            class="filterLabel"
            :class="{ active: item.prop === initParam.param.insuranceType }"
            v-for="item in insuranceTypeOptions"
            :key="item.prop"
            @click="handleTab('insuranceType', item.prop)"
          >
            {{ item.label }}
          </span>
        </div>
        <div style="border-top:1px solid #dcdce1;margin-bottom: 15px;" />
        <div class="recommendFilterItem">
          <span class="filterType">综合排序：</span>
          <span
            class="filterLabel special"
            :class="{ active: item.prop === sortType }"
            v-for="item in sortTypeOptions"
            :key="item.prop"
            @click="handleSort(item)"
          >
            {{ item.label }}
            <template v-if="item.prop !== 'default'">
              <i class="el-icon-sort-down" :class="{ active: item.type === 'down' }" />
              <i class="el-icon-sort-up" :class="{ active: item.type === 'up' }" />
            </template>
          </span>
        </div>
      </div>
      <CardList :list="recommendList" size="small" />
      <Pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pageData="initParam"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </div>
    <MyConsultant />
    <DtCopyright />
  </div>
</template>

<script>
import CardList from './CardList';
import Pagination from '@/components/layouts/Pagination';
import MyConsultant from '@/components/common/MyConsultant';
import DtCopyright from '@/components/layouts/DtCopyright';
import $api from '@/api/recommend';
import { myMixin } from '@/mixins';

export default {
  mixins: [myMixin],
  components: { CardList, Pagination, MyConsultant, DtCopyright },
  data() {
    return {
      dicArr: ["bbc.internetproduct.classify"],
      initParam: {
        pageNum: 1,
        pageSize: 5,
        param: {
          insuranceType: '', // healthy-健康险  accident-意外险
          productType: '', // 1-线下投保  2-在线投保
          sortType: '0', // 0-默认  1-销量DESC 2-销量ASC 3-价格DESC 4-价格ASC 5-上架时间DESC 6-上架时间ASC
          enterpriseId: '',
          isDisplay: '0', // 1-在首页展示  0-顾问心选列表
          typeId:""
        },
      },
      productTypeOptions: [
        { label: '全部', prop: '' },
        { label: '在线投保', prop: '2' },
        { label: '互联网转投', prop: '1' },
      ],
      insuranceTypeOptions: [
        { label: '全部', prop: '' }
      ],
      sortType: 'default',
      sortTypeOptions: [
        { label: '默认', prop: 'default' },
        { label: '销量', prop: 'num', type: '' },
        { label: '价格', prop: 'price', type: '' },
        { label: '上架时间', prop: 'time', type: '' },
      ],
      recommendList: [],
      total: 0,
      typeList:[]
    };
  },
  methods: {
    async init() {
      this.dicMap['bbc.internetproduct.classify'].forEach((item) => {
        this.insuranceTypeOptions.push({
            label: item.dicItemName,
            prop: item.dicItemCode
            });
        })
        await this.getRecommendsTypeList()
      this.queryData();
    },
    async getRecommendsTypeList(){
      this.typeList = [{id:"",typeName:"全部"}]
      const res = await $api.GetRecommendsTypeList({});
      if (res) {
       this.typeList = this.typeList.concat(res)
      }
    },
    queryData() {
      this.initParam.param.enterpriseId = this.$store.state.user.user.defaultEnterpriseId;
      $api.GetRecommends(this.initParam).then(res => {
        if (res && res.list) {
          this.recommendList = res.list;
        } else {
          this.recommendList = [];
        }
        this.total = res.total;
      });
    },
    handleTab(type, value) {
      this.initParam.param[type] = value;
      this.queryData();
    },
    // 排序
    handleSort(item) {
      this.sortType = item.prop;
      // 默认排序，不参与升降逻辑
      if (item.prop !== 'default') {
        item.type = item.type === 'up' ? 'down' : 'up';
      }
      // 根据prop，给默认值，如果是升序，再+1
      let sortType = 0;
      if (item.prop === 'num') {
        sortType = 1;
      } else if (item.prop === 'price') {
        sortType = 3;
      } else if (item.prop === 'time') {
        sortType = 5;
      }
      if (item.type === 'up') sortType += 1;
      this.handleTab('sortType', sortType);
    },
  },
};
</script>

<style lang="less" scoped>
.recommendList {
  background-color: #fff;
  .recommendListWrap {
    width: @contentWidth;
    margin: 30px auto 40px;
  }
  .recommendListTitle {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 20px;
    color: #333;
    span {
      margin-left: 15px;
      font-size: 14px;
      color: var(--primary);
    }
  }
  .recommendListFilter {
    margin-bottom: 20px;
    padding: 25px 20px 10px;
    border: 1px solid #dcdce1;
    border-top: 2px solid var(--primary);
    background-color: #fafafa;
  }
  .recommendFilterItem {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    .filterType {
      color: #999;
    }
    .filterLabel {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      min-width: 82px;
      padding: 7px 12px;
      color: #333;
      border: 1px solid #dcdce1;
      border-radius: 3px;
      background-color: #fafafa;
      text-align: center;
      cursor: pointer;
      transition: 0.5s;
      &:not(:last-of-type) {
        margin-right: 12px;
      }
      &.active {
        color: var(--primary);
        border-color: #e27c00;
        background-color: #fff6e7;
      }
      &:hover {
        color: var(--primary);
        border-color: #e27c00;
        background-color: #fff6e7;
      }
      &.special {
        background-color: #fafafa;
      }
    }
    i {
      font-weight: bold;
      color: #d3d3d3;
      &.active {
        color: var(--primary);
      }
      &.el-icon-sort-down {
        margin-right: -3px;
      }
      &.el-icon-sort-up {
        margin-left: -3px;
      }
    }
  }
}
</style>
